import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VAlert,{staticClass:"error-alert",attrs:{"width":"100%","type":"success","transition":"fade-transition"},model:{value:(_vm.display),callback:function ($$v) {_vm.display=$$v},expression:"display"}},[_vm._v("\n  "+_vm._s(this.message)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }